export default "assets/frame-8.8f3ed18269300d9b.png"